'use strict';

import { Vector2 } from 'three';

export class BuildingShape {
	
	static square() {
		return [
			new Vector2(60,-60),
			new Vector2(240,-60),
			new Vector2(240,-240),
			new Vector2(60,-240),
			new Vector2(60,-60),
		]
	}
	
	static corner() {
		return [
			new Vector2(60,-60),
			new Vector2(240,-60),
			new Vector2(240,-270),
			new Vector2(150,-270),
			new Vector2(150,-150),
			new Vector2(60,-150),
			new Vector2(60,-60),
		]
	}
	
	static rectangle() {
		return [
			new Vector2(60,-60),
			new Vector2(240,-60),
			new Vector2(240,-180),
			new Vector2(60,-180),
			new Vector2(60,-60),
		]
	}
	
	static circle() {
		const radius = 500 / Math.PI / 2;
		const segments = Math.floor(radius);
		const step = Math.PI * 2 / segments;
		let angle = 0;
		const points = [];
		
		for (let i = 0; i < segments; i++) {
			points.push(new Vector2(radius * Math.cos(angle),radius * Math.sin(angle)));
			angle -= step;
		}
		
		return points;
	}
}
